import type { AxiosResponse } from 'axios'
import axios, { isAxiosError } from 'axios'
import type { ResponseWrapper } from '@/api/types'
import { GLOBAL_API_ERROR, GLOBAL_API_REQUEST_ID } from '@/constants/keys'
import auth from '@/lib/auth/oAuth'
import { errorBridge } from '@/lib/error-bridge-state'
import { $env } from '@/lib/location-env'

const URL = process.env.PUBLIC_MERCHANT_API_URL

const client = axios.create({
  baseURL: URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 对请求前的拦截器
client.interceptors.request.use(
  async (config) => {
    const token = await auth.getToken()

    config.headers['Authorization'] = token

    if ($env.localhost) {
      config.headers['X-loloyal-token'] = process.env.PUBLIC_TEST_SHOP_TOKEN
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 对响应的拦截器
client.interceptors.response.use(
  (response: AxiosResponse<ResponseWrapper>) => {
    return response
  },
  (error: any) => {
    if (isAxiosError(error) && error.status === 401) {
      // 401 错误不经过 errorBridge，直接抛出
    } else {
      // 抛出报错内容，用于 banner 展示
      const message = error.response?.data?.message || error.message
      errorBridge.show(
        GLOBAL_API_ERROR,
        `${message} in ${error.config.url}`,
        error?.response?.headers?.[GLOBAL_API_REQUEST_ID],
      )
    }
    return Promise.reject(error)
  },
)

export default client
